var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.541504 8.99984C0.541504 4.32843 4.32843 0.541504 8.99984 0.541504C13.6712 0.541504 17.4582 4.32843 17.4582 8.99984C17.4582 13.6712 13.6712 17.4582 8.99984 17.4582C4.32843 17.4582 0.541504 13.6712 0.541504 8.99984ZM7.0058 5.82729C6.68036 5.50185 6.15273 5.50185 5.82729 5.82729C5.50185 6.15273 5.50185 6.68036 5.82729 7.0058L7.82137 8.99988L5.82729 10.994C5.50185 11.3194 5.50185 11.847 5.82729 12.1725C6.15273 12.4979 6.68036 12.4979 7.0058 12.1725L8.99988 10.1784L10.994 12.1725C11.3194 12.4979 11.847 12.4979 12.1725 12.1725C12.4979 11.847 12.4979 11.3194 12.1725 10.994L10.1784 8.99988L12.1725 7.0058C12.4979 6.68036 12.4979 6.15273 12.1725 5.82729C11.847 5.50185 11.3194 5.50185 10.994 5.82729L8.99988 7.82137L7.0058 5.82729Z",
    fill: "#E02D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.5206397bce6b50a479d1027ae75fb2ea.svg";
export { ForwardRef as ReactComponent };